<template>
  <div class="flex flex-row gap-16 max-w-screen-md mt-32 mb-80">
    <NuxtLink
      v-for="link in links"
      :key="link.to"
      class="text-text-link standalone hover:text-text-link-hover"
      :to="link.to"
      external
    >
      {{ link.text }}
    </NuxtLink>
  </div>
</template>
<script setup lang="ts">
type ErrorNavLink = {
  to: string;
  text: string;
};

const links: ErrorNavLink[] = [
  { to: '/mobiltelefoner', text: 'Shoppen' },
  { to: '/support', text: 'Supporten' },
  { to: '/mitt-halebop', text: 'Mitt Halebop' },
];
</script>

<style></style>
